import React, { useState, useEffect, useMemo, useRef, useContext, memo  } from "react";
//import { Droppable, DroppableProvided as droppableProvided, DraggableStateSnapshot, DroppableStateSnapshot } from 'react-beautiful-dnd';
import {
	Button,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Toolbar,
	Tooltip
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import MaterialTableLineItemRow from './MaterialTableLineItemRow';
import DataHeaderCell from '../orders/DataHeaderCell'
import { Scrollbars } from "react-custom-scrollbars-2";
import ColumnResize from "react-table-column-resizer";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export const MaterialTableLineItems = memo(({checkedId, handleChange, updateBasket, buySellClick, inputValues, info ,source, basketId, lineItems, columns, isBasketAdded, isSingleLeg, isDark }) => {
	const totalGreeks = useMemo(() => {
		const sum = (key) =>
			(lineItems || []).reduce((acc, p) => acc + (Number(p?.[key]) || 0), 0);
		return {
			iv: sum('iv'),
			delta: sum('delta'),
			theta: sum('theta'),
			vega: sum('vega'),
			gamma: sum('gamma')
		};
	}, [lineItems]);

	const getGreekColor = (val) => {
		if (Number(val) === 0) return '';
		if (Number(val) > 0) return isDark ? '#00d27a' : '#16a34a';
		return isDark ? '#F87171' : '#E74C3C';
	};

	return (
		 
		<div>
			<Table className='opt-chn-tbl' style={{ width: "max-content", tableLayout: "fixed" }}>
				<colgroup>
					<col style={{ width: '1%' }} />
					<col style={{ width: '200px', position: "sticky" }} />
				</colgroup>
				<TableHead className="pos-tbl-head" style={isSingleLeg ? { position: "sticky", top: 0, zIndex: 250, backgroundColor: isDark ? "" : "#fff" } : {}}>
					<TableRow>
						<TableCell align="left" className=" dataCell">
							<FormControlLabel
								control={
									<Checkbox
										style={{ padding: 0, margin: 0 }}
										checked={lineItems.length > 0 && lineItems.every(item => checkedId.some(id => id == item.id))}
										onChange={(e) => handleChange(e.target.checked, lineItems, '1')}
										name={""}
									/>
								}
								label={""}
								style={{ padding: 0, margin: 0 }}
							/>
						</TableCell>
						{columns[0]?.positionHeader?.map((obj) => (
							<React.Fragment key={obj.accessorKey}>
							  {obj.enableColumn &&
							   <>
							    <DataHeaderCell
									key={obj.accessorKey}
									dkey={obj.accessorKey}
									name={obj.header}
									align={obj.align}
									updateSortProperty={null}
									width={obj.width}
								/>
								 
								 {/* <ColumnResize
									id={"fno-table-header-cell"}
									resizeEnd={(width) => console.log("resize end", width)}
									resizeStart={() => console.log("resize start")}
									className="columnResizer"
									 
								/> */}
							</>
                          }	 
							</React.Fragment>
							
							))}
						 
					</TableRow>
				</TableHead>
				{/* <Droppable droppableId={basketId.toString()} direction="vertical" type="droppableItem">
					{(
						droppableProvided,
					) => ( */}
						<TableBody
						 //ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}
						 >
							{lineItems.length === 0 ? (
								<TableRow>
									<TableCell align="center" colSpan={10}>
										<div>No Data</div>
									</TableCell>
								</TableRow>
							) : (
								lineItems.map((item, index) => (
									<MaterialTableLineItemRow
										key={item.id}
										text={item.id.toString()}
										index={index}
										rowData={item}
										columns={columns[0]?.positionHeader}
										isBasketAdded={isBasketAdded}
										source={source}
										info={info}
										inputValues={inputValues}
										buySellClick={buySellClick}
										updateBasket={updateBasket}
										handleChange={handleChange}
										checkedId={checkedId}
										
									/>
								))
							)}
							{lineItems.length > 0 && columns[0]?.strategyHeader?.find(item => item.accessorKey === "showTotalGreeks")?.enableColumn && 
							 ["delta", "theta", "vega", "gamma"].some(key => columns[0]?.positionHeader?.find(item => item.accessorKey === key)?.enableColumn) && (
								<TableRow>
									<TableCell className="dataCell" />
									{columns[0]?.positionHeader?.map((obj, i) => {
										if (!obj.enableColumn) return null;
										
										const visibleColumns = columns[0]?.positionHeader?.filter(c => c.enableColumn);
										const isFirstVisible = visibleColumns[0]?.accessorKey === obj.accessorKey;

										if (isFirstVisible) {
											return (
												<TableCell key="total-label" className="dataCell" style={{ fontWeight: 600 }}>
													Total Greeks
												</TableCell>
											);
										}

										if (["delta", "theta", "vega", "gamma"].includes(obj.accessorKey)) {
											const val = totalGreeks[obj.accessorKey];
											return (
												<TableCell key={obj.accessorKey} align={obj.align} className="dataCell">
													<span style={{ color: getGreekColor(val), fontWeight: 600, fontSize: 13 }}>
														{val > 0 ? '+' : ''}{Number(val || 0).toFixed(obj.accessorKey === "gamma" ? 4 : 2)}
													</span>
												</TableCell>
											);
										}

										return <TableCell key={i} className="dataCell" />;
									})}
								</TableRow>
							)}
							{/* {droppableProvided.placeholder} */}
						</TableBody>
					{/* )}
				</Droppable> */}
			</Table>
		 </div>
	)
	 
});
